import { apiFactory } from "@/api/factories/apiFactory";
class pageChangeService {
    _pageChangeApi = apiFactory.usePageChangeApi();
    async pageChange(currentPageName, newPageName, route) {
        const response = await this._pageChangeApi.pageChange(currentPageName, newPageName, route);
        return response.success;
    }
}
export default pageChangeService;
